import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CompletionSystemPage from "./pages/Completion";
import ConstructionManagementPage from "./pages/Construction";
import LogisticsManagementSystem from "./pages/Logistics";
import PipePrefabricationSystem from "./pages/Pipe";
import SiteManagementPage from "./pages/SiteManagement";
import SmartSpool from "./pages/SmartSpool";
import WarehousingAndMaterials from "./pages/Warehousing";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/completion-system" element={<CompletionSystemPage />} />
          <Route path="/construction-management" element={<ConstructionManagementPage />} />
          <Route path="/logistics-management" element={<LogisticsManagementSystem />} />
          <Route path="/pipe-prefabrication" element={<PipePrefabricationSystem />} />
          <Route path="/site-management" element={<SiteManagementPage />} />
          <Route path="/smart-spool" element={<SmartSpool />} />
          <Route path="/warehousing-materials" element={<WarehousingAndMaterials />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;